webpackJsonp([0],{

/***/ 1252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blueprintjs_core__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blueprintjs_select__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_free_brands_svg_icons__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_react_fontawesome__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_node_fetch__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_node_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_node_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_page__ = __webpack_require__(226);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var bedroomArr=[{id:1,bhk:'1BHK'},{id:2,bhk:'2BHK'},{id:3,bhk:'3BHK'},{id:4,bhk:'4BHK'},{id:5,bhk:'5BHK'}];var budgetRent=[{id:1,price:'Upto 5K',max:5000},{id:2,price:'Upto 10k',max:10000},{id:3,price:'Upto 20K',max:20000},{id:4,price:'Upto 30K',max:30000},{id:5,price:'Upto 40K',max:40000},{id:6,price:'Upto 50K',max:50000},{id:7,price:'Upto 60K',max:60000},{id:8,price:'Upto 70K',max:70000},{id:9,price:'Upto 80K',max:80000},{id:10,price:'Upto 90K',max:90000},{id:11,price:'Upto 1L',max:100000},{id:12,price:'Upto 1.5L',max:150000},{id:13,price:'Upto 2L',max:100000},{id:14,price:'Upto 5L',max:500000},{id:15,price:'Upto 10L',max:1000000}];var budgetSale=[{id:1,price:'Upto 5L',max:500000},{id:2,price:'Upto 10L',max:1000000},{id:3,price:'Upto 20L',max:2000000},{id:4,price:'Upto 30L',max:3000000},{id:5,price:'Upto 40L',max:4000000},{id:6,price:'Upto 50L',max:5000000},{id:7,price:'Upto 60L',max:6000000},{id:8,price:'Upto 70L',max:7000000},{id:9,price:'Upto 80L',max:8000000},{id:10,price:'Upto 90L',max:9000000},{id:11,price:'Upto 1CR',max:10000000},{id:12,price:'Upto 1.5CR',max:15000000},{id:13,price:'Upto 2CR',max:20000000},{id:14,price:'Upto 3CR',max:30000000},{id:15,price:'Upto 5CR',max:50000000},{id:16,price:'Upto 10CR',max:100000000},{id:17,price:'Upto 15CR',max:150000000},{id:18,price:'Upto 20CR',max:200000000},{id:19,price:'Upto 30CR',max:300000000},{id:20,price:'Upto 40CR',max:400000000},{id:21,price:'Upto 50CR',max:500000000}];var Homepage=function(_React$Component){_inherits(Homepage,_React$Component);function Homepage(props){_classCallCheck(this,Homepage);var _this=_possibleConstructorReturn(this,(Homepage.__proto__||Object.getPrototypeOf(Homepage)).call(this,props));_this.handleSearchClick=function(){if(_this.state.locationText==null){_this.setState({errorMsg:'Please select a location to continue search'});}else{var urlQueries=[];if(_this.state.locationText!==null){urlQueries.push("areaUid="+_this.state.locationText.uid);}if(_this.state.budget!==null){if(_this.state.budget.max){urlQueries.push("maxPrice="+_this.state.budget.max);}if(_this.state.budget.min){urlQueries.push("minPrice="+_this.state.budget.min);}}if(_this.state.bhkText!==null){urlQueries.push("bedrooms="+_this.state.bhkText.id);}_this.props.history.push({pathname:_this.state.inventoryType==='buy'?"/search/buy":"search/rent",search:"?"+urlQueries.join('&')});};};_this.itemLocationRenderer=function(item,_ref){var handleClick=_ref.handleClick;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__blueprintjs_core__["r" /* MenuItem */],{key:item.uid,text:item.name+" ("+_this.state.city.name+")",onClick:handleClick,shouldDismissPopover:true});};_this.handleclick=function(item){//now this runs
if(typeof item.name!=='undefined'){_this.setState({locationText:item});}else if(typeof item.bhk!=='undefined'){_this.setState({bhkText:item});}else if(typeof item.price!=='undefined'){_this.setState({budget:item});}};_this.handleInventoryTypeChange=function(value){_this.setState({inventoryType:value});};_this.state={inventoryType:'buy',bhkText:null,locationText:null,location:[],city:{uid:'navi-mumbai',name:'Navi Mumbai'},budget:null,errorMsg:''};return _this;}_createClass(Homepage,[{key:"fetchCities",value:function fetchCities(){var _this2=this;var URL='/v1/city-areas?cityUid='+this.state.city.uid;__WEBPACK_IMPORTED_MODULE_4_node_fetch___default()(URL).then(function(response){return response.json();}).then(function(result){if(result.message!=='Ok'){return;}_this2.setState({location:result.data});});}},{key:"componentDidMount",value:function componentDidMount(){this.fetchCities();}},{key:"itemRenderer",value:function itemRenderer(item,_ref2){var handleClick=_ref2.handleClick;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__blueprintjs_core__["r" /* MenuItem */],{key:item.id,text:item.bhk,onClick:handleClick,shouldDismissPopover:true});}},{key:"budgetItemRenderer",value:function budgetItemRenderer(item,_ref3){var handleClick=_ref3.handleClick;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__blueprintjs_core__["r" /* MenuItem */],{key:item.id,text:item.price,onClick:handleClick,shouldDismissPopover:true});}},{key:"render",value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_page__["a" /* default */],{id:"homepage"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("section",{className:"hero has-background-white home-hero"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"hero-body"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h1",{className:"title tacenter"},"Buy / Rent Property Directly from Society"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"search-box"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"tabs is-toggle has-text-centered"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li",{className:this.state.inventoryType=="buy"?"is-active":""},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("a",{onClick:function onClick(){_this3.handleInventoryTypeChange("buy");}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span",null,"Buy"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li",{className:this.state.inventoryType=="rent"?"is-active":""},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("a",{onClick:function onClick(){_this3.handleInventoryTypeChange("rent");}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span",null,"Rent"))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__blueprintjs_core__["g" /* ControlGroup */],{fill:true,vertical:false},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"selectBox"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__blueprintjs_select__["a" /* Select */],{items:this.state.location,filterable:false,itemRenderer:this.itemLocationRenderer,onItemSelect:this.handleclick,closeOnSelect:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__blueprintjs_core__["c" /* Button */],{large:true,rightIcon:"caret-down",text:this.state.locationText?this.state.locationText.name:'Select Location'})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__blueprintjs_select__["a" /* Select */],{items:bedroomArr,filterable:false,itemRenderer:this.itemRenderer,onItemSelect:this.handleclick,closeOnSelect:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__blueprintjs_core__["c" /* Button */],{large:true,rightIcon:"caret-down",text:this.state.bhkText?this.state.bhkText.bhk:'Any BHK'})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__blueprintjs_select__["a" /* Select */],{items:this.state.inventoryType==="buy"?budgetSale:budgetRent,filterable:false,itemRenderer:this.budgetItemRenderer,onItemSelect:this.handleclick,closeOnSelect:true,popoverProps:{popoverClassName:"tall-popover",position:__WEBPACK_IMPORTED_MODULE_0__blueprintjs_core__["u" /* Position */].BOTTOM,modifiers:{arrow:{enabled:true},preventOverflow:{enabled:false,boundariesElement:"window"}}}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__blueprintjs_core__["c" /* Button */],{large:true,rightIcon:"caret-down",text:this.state.budget?this.state.budget.price:'Select Budget'})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__blueprintjs_core__["c" /* Button */],{large:true,intent:"success",icon:"search",text:"Search",style:{borderRadius:0,justifyContent:"center"},onClick:this.handleSearchClick})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("section",{className:"content home-search-content"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("p",{className:"has-text-danger home-search-error"},this.state.errorMsg),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h2",null,"24x7 assistance"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h2",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__fortawesome_react_fontawesome__["a" /* FontAwesomeIcon */],{icon:__WEBPACK_IMPORTED_MODULE_2__fortawesome_free_brands_svg_icons__["c" /* faWhatsapp */]})," 7045655225"))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("section",{className:"hero is-bold has-space"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"hero-body"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h2",{className:"title title-light tacenter is-size-2"},"Why MyHomeKart?"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"home-card"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("figure",{className:"image is-128x128 has-text-success"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i",{className:"flaticon-medal flat-icon"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"Right Advice"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("p",null,"We provide authentic advice to owner/buyer/tenant to avoid any dispute."))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"home-card"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("figure",{className:"image is-128x128 has-text-success"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i",{className:"flaticon-list flat-icon"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"Verified Properties"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("p",null,"We do background check of both property and owner/buyer/tenant for smooth deal."))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"home-card"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("figure",{className:"image is-128x128 has-text-success"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i",{className:"flaticon-statistics flat-icon"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"End-to-End Service"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("p",null,"We provide end to end service for all your property needs"))))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("section",{className:"hero is-bold has-space has-background-white"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"hero-body"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h2",{className:"title title-light tacenter is-size-2"},"Online Rent Agreement"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"home-card"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("figure",{className:"image is-128x128 has-text-info"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i",{className:"flaticon-monitor flat-icon"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",{className:"hast-text-grey"},"Provide Information"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"home-card"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("figure",{className:"image is-128x128 has-text-info"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i",{className:"flaticon-bank flat-icon"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",{className:"hast-text-grey"},"Make Payment"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"home-card"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("figure",{className:"image is-128x128 has-text-info"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i",{className:"flaticon-fingerprint flat-icon"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",{className:"hast-text-grey"},"Biometric Collected"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"home-card"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("figure",{className:"image is-128x128 has-text-info"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i",{className:"flaticon-document flat-icon"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",{className:"hast-text-grey"},"Download Agreement")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("section",{className:"section"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"btn-block"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],{to:"/rentagreement",className:"bp3-button bp3-intent-primary bp3-fill bp3-large"},"Get Rent Agreement")))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("section",{className:"hero is-success"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"hero-body"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"container tacenter"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h2",{className:"title title-light is-size-2"},"Are you a Housing Society?"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"columns",style:{marginBottom:'2rem',marginTop:'2rem'}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"society-card"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("figure",{className:"image is-128x128"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i",{className:"flaticon-money flat-icon"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"Get Brokerage Revenue Share"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"society-card"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("figure",{className:"image is-128x128"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("i",{className:"flaticon-down flat-icon"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"Reduce Maintainence Cost"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"column"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"society-card"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("figure",{className:"image is-128x128"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("svg",{className:"icon-svg"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("use",{xlinkHref:"#login"}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"Collaborate Digitally")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"btn-block has-text-dark"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],{to:"/societyjoin",className:"bp3-button bp3-fill bp3-large"},"Join Us"))))));}}]);return Homepage;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);// export default () => (
//   <Page id="homepage">
//     <p>Here's our homepage. All are welcome.</p>
//     <img src={logo} alt="Homepage" style={{ width: '400px' }} />
//   </Page>
// );
/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["d" /* withRouter */])(Homepage));

/***/ }),

/***/ 1253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes__ = __webpack_require__(1256);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__classes__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__itemListRenderer__ = __webpack_require__(1257);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__itemListRenderer__["a"]; });
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */



//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryList; });
/* unused harmony export getFirstEnabledItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(1253);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */




var QueryList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](QueryList, _super);
    function QueryList(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.refHandlers = {
            itemsParent: function (ref) { return (_this.itemsParentRef = ref); },
        };
        /**
         * Flag indicating that we should check whether selected item is in viewport
         * after rendering, typically because of keyboard change. Set to `true` when
         * manipulating state in a way that may cause active item to scroll away.
         */
        _this.shouldCheckActiveItemInViewport = false;
        /** default `itemListRenderer` implementation */
        _this.renderItemList = function (listProps) {
            var _a = _this.props, initialContent = _a.initialContent, noResults = _a.noResults;
            var menuContent = Object(__WEBPACK_IMPORTED_MODULE_3__common__["b" /* renderFilteredItems */])(listProps, noResults, initialContent);
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["q" /* Menu */], { ulRef: listProps.itemsParentRef }, menuContent);
        };
        /** wrapper around `itemRenderer` to inject props */
        _this.renderItem = function (item, index) {
            var _a = _this.state, activeItem = _a.activeItem, query = _a.query;
            var matchesPredicate = _this.state.filteredItems.indexOf(item) >= 0;
            var modifiers = {
                active: activeItem === item,
                disabled: isItemDisabled(item, index, _this.props.itemDisabled),
                matchesPredicate: matchesPredicate,
            };
            return _this.props.itemRenderer(item, {
                handleClick: function (e) { return _this.handleItemSelect(item, e); },
                index: index,
                modifiers: modifiers,
                query: query,
            });
        };
        _this.handleItemSelect = function (item, event) {
            _this.setActiveItem(item);
            __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["A" /* Utils */].safeInvoke(_this.props.onItemSelect, item, event);
            if (_this.props.resetOnSelect) {
                _this.setQuery("", true);
            }
        };
        _this.handleKeyDown = function (event) {
            var keyCode = event.keyCode;
            if (keyCode === __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["p" /* Keys */].ARROW_UP || keyCode === __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["p" /* Keys */].ARROW_DOWN) {
                event.preventDefault();
                var nextActiveItem = _this.getNextActiveItem(keyCode === __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["p" /* Keys */].ARROW_UP ? -1 : 1);
                if (nextActiveItem != null) {
                    _this.setActiveItem(nextActiveItem);
                }
            }
            __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["A" /* Utils */].safeInvoke(_this.props.onKeyDown, event);
        };
        _this.handleKeyUp = function (event) {
            var onKeyUp = _this.props.onKeyUp;
            var activeItem = _this.state.activeItem;
            // using keyup for enter to play nice with Button's keyboard clicking.
            // if we were to process enter on keydown, then Button would click itself on keyup
            // and the popvoer would re-open out of our control :(.
            if (event.keyCode === __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["p" /* Keys */].ENTER && activeItem != null) {
                event.preventDefault();
                _this.handleItemSelect(activeItem, event);
            }
            __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["A" /* Utils */].safeInvoke(onKeyUp, event);
        };
        _this.handleQueryChange = function (event) {
            var query = event == null ? "" : event.target.value;
            _this.setQuery(query);
            __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["A" /* Utils */].safeInvoke(_this.props.onQueryChange, query, event);
        };
        var _a = _this.props.query, query = _a === void 0 ? "" : _a;
        var filteredItems = getFilteredItems(query, _this.props);
        _this.state = { activeItem: getFirstEnabledItem(filteredItems, _this.props.itemDisabled), filteredItems: filteredItems, query: query };
        return _this;
    }
    QueryList.ofType = function () {
        return QueryList;
    };
    QueryList.prototype.render = function () {
        var _a = this.props, className = _a.className, items = _a.items, renderer = _a.renderer, _b = _a.itemListRenderer, itemListRenderer = _b === void 0 ? this.renderItemList : _b;
        return renderer(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.state, { className: className, handleItemSelect: this.handleItemSelect, handleKeyDown: this.handleKeyDown, handleKeyUp: this.handleKeyUp, handleQueryChange: this.handleQueryChange, itemList: itemListRenderer(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.state, { items: items, itemsParentRef: this.refHandlers.itemsParent, renderItem: this.renderItem })) }));
    };
    QueryList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.activeItem !== undefined) {
            this.shouldCheckActiveItemInViewport = true;
            this.setState({ activeItem: nextProps.activeItem });
        }
        if (nextProps.query != null) {
            this.setQuery(nextProps.query);
        }
    };
    QueryList.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (!__WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["A" /* Utils */].shallowCompareKeys(this.props, prevProps, {
            include: ["items", "itemListPredicate", "itemPredicate"],
        })) {
            this.setQuery(this.state.query);
        }
        if (this.shouldCheckActiveItemInViewport) {
            // update scroll position immediately before repaint so DOM is accurate
            // (latest filteredItems) and to avoid flicker.
            requestAnimationFrame(function () { return _this.scrollActiveItemIntoView(); });
            // reset the flag
            this.shouldCheckActiveItemInViewport = false;
        }
    };
    QueryList.prototype.scrollActiveItemIntoView = function () {
        var activeElement = this.getActiveElement();
        if (this.itemsParentRef != null && activeElement != null) {
            var activeTop = activeElement.offsetTop, activeHeight = activeElement.offsetHeight;
            var _a = this.itemsParentRef, parentOffsetTop = _a.offsetTop, parentScrollTop = _a.scrollTop, parentHeight = _a.clientHeight;
            // compute padding on parent element to ensure we always leave space
            var _b = this.getItemsParentPadding(), paddingTop = _b.paddingTop, paddingBottom = _b.paddingBottom;
            // compute the two edges of the active item for comparison, including parent padding
            var activeBottomEdge = activeTop + activeHeight + paddingBottom - parentOffsetTop;
            var activeTopEdge = activeTop - paddingTop - parentOffsetTop;
            if (activeBottomEdge >= parentScrollTop + parentHeight) {
                // offscreen bottom: align bottom of item with bottom of viewport
                this.itemsParentRef.scrollTop = activeBottomEdge + activeHeight - parentHeight;
            }
            else if (activeTopEdge <= parentScrollTop) {
                // offscreen top: align top of item with top of viewport
                this.itemsParentRef.scrollTop = activeTopEdge - activeHeight;
            }
        }
    };
    QueryList.prototype.setQuery = function (query, resetActiveItem) {
        if (resetActiveItem === void 0) { resetActiveItem = this.props.resetOnQuery; }
        this.shouldCheckActiveItemInViewport = true;
        if (query !== this.state.query) {
            __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["A" /* Utils */].safeInvoke(this.props.onQueryChange, query);
        }
        var filteredItems = getFilteredItems(query, this.props);
        this.setState({ filteredItems: filteredItems, query: query });
        // always reset active item if it's now filtered or disabled
        var activeIndex = this.getActiveIndex(filteredItems);
        if (resetActiveItem ||
            activeIndex < 0 ||
            isItemDisabled(this.state.activeItem, activeIndex, this.props.itemDisabled)) {
            this.setActiveItem(getFirstEnabledItem(filteredItems, this.props.itemDisabled));
        }
    };
    QueryList.prototype.getActiveElement = function () {
        if (this.itemsParentRef != null) {
            return this.itemsParentRef.children.item(this.getActiveIndex());
        }
        return undefined;
    };
    QueryList.prototype.getActiveIndex = function (items) {
        if (items === void 0) { items = this.state.filteredItems; }
        var activeItem = this.state.activeItem;
        // NOTE: this operation is O(n) so it should be avoided in render(). safe for events though.
        return activeItem == null ? -1 : items.indexOf(activeItem);
    };
    QueryList.prototype.getItemsParentPadding = function () {
        // assert ref exists because it was checked before calling
        var _a = getComputedStyle(this.itemsParentRef), paddingTop = _a.paddingTop, paddingBottom = _a.paddingBottom;
        return {
            paddingBottom: pxToNumber(paddingBottom),
            paddingTop: pxToNumber(paddingTop),
        };
    };
    /**
     * Get the next enabled item, moving in the given direction from the start
     * index. An `undefined` return value means no suitable item was found.
     * @param direction amount to move in each iteration, typically +/-1
     */
    QueryList.prototype.getNextActiveItem = function (direction, startIndex) {
        if (startIndex === void 0) { startIndex = this.getActiveIndex(); }
        return getFirstEnabledItem(this.state.filteredItems, this.props.itemDisabled, direction, startIndex);
    };
    QueryList.prototype.setActiveItem = function (activeItem) {
        if (this.props.activeItem === undefined) {
            // indicate that the active item may need to be scrolled into view after update.
            this.shouldCheckActiveItemInViewport = true;
            this.setState({ activeItem: activeItem });
        }
        __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["A" /* Utils */].safeInvoke(this.props.onActiveItemChange, activeItem);
    };
    QueryList.displayName = __WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["h" /* DISPLAYNAME_PREFIX */] + ".QueryList";
    QueryList.defaultProps = {
        resetOnQuery: true,
    };
    return QueryList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function pxToNumber(value) {
    return value == null ? 0 : parseInt(value.slice(0, -2), 10);
}
function getFilteredItems(query, _a) {
    var items = _a.items, itemPredicate = _a.itemPredicate, itemListPredicate = _a.itemListPredicate;
    if (__WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["A" /* Utils */].isFunction(itemListPredicate)) {
        // note that implementations can reorder the items here
        return itemListPredicate(query, items);
    }
    else if (__WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["A" /* Utils */].isFunction(itemPredicate)) {
        return items.filter(function (item, index) { return itemPredicate(query, item, index); });
    }
    return items;
}
/** Wrap number around min/max values: if it exceeds one bound, return the other. */
function wrapNumber(value, min, max) {
    if (value < min) {
        return max;
    }
    else if (value > max) {
        return min;
    }
    return value;
}
function isItemDisabled(item, index, itemDisabled) {
    if (itemDisabled == null || item == null) {
        return false;
    }
    else if (__WEBPACK_IMPORTED_MODULE_2__blueprintjs_core__["A" /* Utils */].isFunction(itemDisabled)) {
        return itemDisabled(item, index);
    }
    return !!item[itemDisabled];
}
/**
 * Get the next enabled item, moving in the given direction from the start
 * index. An `undefined` return value means no suitable item was found.
 * @param items the list of items
 * @param isItemDisabled callback to determine if a given item is disabled
 * @param direction amount to move in each iteration, typically +/-1
 * @param startIndex which index to begin moving from
 */
function getFirstEnabledItem(items, itemDisabled, direction, startIndex) {
    if (direction === void 0) { direction = 1; }
    if (startIndex === void 0) { startIndex = items.length - 1; }
    if (items.length === 0) {
        return null;
    }
    // remember where we started to prevent an infinite loop
    var index = startIndex;
    var maxIndex = items.length - 1;
    do {
        // find first non-disabled item
        index = wrapNumber(index + direction, 0, maxIndex);
        if (!isItemDisabled(items[index], index, itemDisabled)) {
            return items[index];
        }
    } while (index !== startIndex);
    return null;
}
//# sourceMappingURL=queryList.js.map

/***/ }),

/***/ 1255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(1253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(1258);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__components__["a"]; });
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */


//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MULTISELECT", function() { return MULTISELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MULTISELECT_POPOVER", function() { return MULTISELECT_POPOVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OMNIBAR", function() { return OMNIBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OMNIBAR_OVERLAY", function() { return OMNIBAR_OVERLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT", function() { return SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT_POPOVER", function() { return SELECT_POPOVER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blueprintjs_core__ = __webpack_require__(13);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */

var NS = __WEBPACK_IMPORTED_MODULE_0__blueprintjs_core__["f" /* Classes */].getClassNamespace();
var MULTISELECT = NS + "-multi-select";
var MULTISELECT_POPOVER = MULTISELECT + "-popover";
var OMNIBAR = NS + "-omnibar";
var OMNIBAR_OVERLAY = OMNIBAR + "-overlay";
var SELECT = NS + "-select";
var SELECT_POPOVER = SELECT + "-popover";
//# sourceMappingURL=classes.js.map

/***/ }),

/***/ 1257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = renderFilteredItems;
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
/**
 * `ItemListRenderer` helper method for rendering each item in `filteredItems`,
 * with optional support for `noResults` (when filtered items is empty)
 * and `initialContent` (when query is empty).
 */
function renderFilteredItems(props, noResults, initialContent) {
    if (props.query.length === 0 && initialContent !== undefined) {
        return initialContent;
    }
    var items = props.filteredItems.map(props.renderItem).filter(function (item) { return item != null; });
    return items.length > 0 ? items : noResults;
}
//# sourceMappingURL=itemListRenderer.js.map

/***/ }),

/***/ 1258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__omnibar_omnibar__ = __webpack_require__(1259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__query_list_queryList__ = __webpack_require__(1254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__select_multiSelect__ = __webpack_require__(1260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__select_select__ = __webpack_require__(1261);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__select_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__select_suggest__ = __webpack_require__(1262);
/* unused harmony namespace reexport */
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */





//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Omnibar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__query_list_queryList__ = __webpack_require__(1254);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */






var Omnibar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](Omnibar, _super);
    function Omnibar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.TypedQueryList = __WEBPACK_IMPORTED_MODULE_5__query_list_queryList__["a" /* QueryList */].ofType();
        _this.refHandlers = {
            queryList: function (ref) { return (_this.queryList = ref); },
        };
        _this.renderQueryList = function (listProps) {
            var _a = _this.props, _b = _a.inputProps, inputProps = _b === void 0 ? {} : _b, isOpen = _a.isOpen, _c = _a.overlayProps, overlayProps = _c === void 0 ? {} : _c;
            var handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
            var handlers = isOpen && listProps.query.length > 0 ? { onKeyDown: handleKeyDown, onKeyUp: handleKeyUp } : {};
            return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["s" /* Overlay */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ hasBackdrop: true }, overlayProps, { isOpen: isOpen, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].OMNIBAR_OVERLAY, overlayProps.className), onClose: _this.handleOverlayClose }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].OMNIBAR, listProps.className) }, handlers),
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["n" /* InputGroup */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ autoFocus: true, large: true, leftIcon: "search", placeholder: "Search..." }, inputProps, { onChange: listProps.handleQueryChange, value: listProps.query })),
                    listProps.itemList)));
        };
        _this.handleOverlayClose = function (event) {
            var _a = _this.props.overlayProps, overlayProps = _a === void 0 ? {} : _a;
            __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(overlayProps.onClose, event);
            __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(_this.props.onClose, event);
        };
        return _this;
    }
    Omnibar.ofType = function () {
        return Omnibar;
    };
    Omnibar.prototype.render = function () {
        // omit props specific to this component, spread the rest.
        var _a = this.props, _b = _a.initialContent, initialContent = _b === void 0 ? null : _b, isOpen = _a.isOpen, inputProps = _a.inputProps, overlayProps = _a.overlayProps, restProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */](_a, ["initialContent", "isOpen", "inputProps", "overlayProps"]);
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](this.TypedQueryList, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, restProps, { initialContent: initialContent, onItemSelect: this.props.onItemSelect, ref: this.refHandlers.queryList, renderer: this.renderQueryList })));
    };
    Omnibar.displayName = __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["h" /* DISPLAYNAME_PREFIX */] + ".Omnibar";
    return Omnibar;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]));

//# sourceMappingURL=omnibar.js.map

/***/ }),

/***/ 1260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MultiSelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__query_list_queryList__ = __webpack_require__(1254);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the terms of the LICENSE file distributed with this project.
 */






var MultiSelect = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](MultiSelect, _super);
    function MultiSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: (_this.props.popoverProps && _this.props.popoverProps.isOpen) || false,
        };
        _this.TypedQueryList = __WEBPACK_IMPORTED_MODULE_5__query_list_queryList__["a" /* QueryList */].ofType();
        _this.refHandlers = {
            input: function (ref) {
                _this.input = ref;
                var _a = _this.props.tagInputProps, tagInputProps = _a === void 0 ? {} : _a;
                __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(tagInputProps.inputRef, ref);
            },
            queryList: function (ref) { return (_this.queryList = ref); },
        };
        _this.renderQueryList = function (listProps) {
            var _a = _this.props, _b = _a.tagInputProps, tagInputProps = _b === void 0 ? {} : _b, _c = _a.popoverProps, popoverProps = _c === void 0 ? {} : _c, _d = _a.selectedItems, selectedItems = _d === void 0 ? [] : _d, placeholder = _a.placeholder;
            var handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
            return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["t" /* Popover */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ autoFocus: false, canEscapeKeyClose: true, enforceFocus: false, isOpen: _this.state.isOpen, position: __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["u" /* Position */].BOTTOM_LEFT }, popoverProps, { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(listProps.className, popoverProps.className), onInteraction: _this.handlePopoverInteraction, popoverClassName: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].MULTISELECT_POPOVER, popoverProps.popoverClassName), onOpened: _this.handlePopoverOpened }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { onKeyDown: _this.getTargetKeyDownHandler(handleKeyDown), onKeyUp: _this.state.isOpen ? handleKeyUp : undefined },
                    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["y" /* TagInput */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ placeholder: placeholder }, tagInputProps, { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].MULTISELECT, tagInputProps.className), inputRef: _this.refHandlers.input, inputValue: listProps.query, onInputChange: listProps.handleQueryChange, values: selectedItems.map(_this.props.tagRenderer) }))),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { onKeyDown: _this.getTargetKeyDownHandler(handleKeyDown), onKeyUp: handleKeyUp }, listProps.itemList)));
        };
        _this.handleItemSelect = function (item, evt) {
            if (_this.input != null) {
                _this.input.focus();
            }
            __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(_this.props.onItemSelect, item, evt);
        };
        _this.handleQueryChange = function (query, evt) {
            _this.setState({ isOpen: query.length > 0 || !_this.props.openOnKeyDown });
            __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(_this.props.onQueryChange, query, evt);
        };
        _this.handlePopoverInteraction = function (nextOpenState) {
            return requestAnimationFrame(function () {
                // deferring to rAF to get properly updated activeElement
                var _a = _this.props.popoverProps, popoverProps = _a === void 0 ? {} : _a;
                if (_this.input != null && _this.input !== document.activeElement) {
                    // the input is no longer focused so we can close the popover
                    _this.setState({ isOpen: false });
                }
                else if (!_this.props.openOnKeyDown) {
                    // open the popover when focusing the tag input
                    _this.setState({ isOpen: true });
                }
                __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(popoverProps.onInteraction, nextOpenState);
            });
        };
        _this.handlePopoverOpened = function (node) {
            var _a = _this.props.popoverProps, popoverProps = _a === void 0 ? {} : _a;
            if (_this.queryList != null) {
                // scroll active item into view after popover transition completes and all dimensions are stable.
                _this.queryList.scrollActiveItemIntoView();
            }
            __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(popoverProps.onOpened, node);
        };
        _this.getTargetKeyDownHandler = function (handleQueryListKeyDown) {
            return function (e) {
                var which = e.which;
                if (which === __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["p" /* Keys */].ESCAPE || which === __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["p" /* Keys */].TAB) {
                    // By default the escape key will not trigger a blur on the
                    // input element. It must be done explicitly.
                    if (_this.input != null) {
                        _this.input.blur();
                    }
                    _this.setState({ isOpen: false });
                }
                else if (!(which === __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["p" /* Keys */].BACKSPACE || which === __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["p" /* Keys */].ARROW_LEFT || which === __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["p" /* Keys */].ARROW_RIGHT)) {
                    _this.setState({ isOpen: true });
                }
                if (_this.state.isOpen) {
                    __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(handleQueryListKeyDown, e);
                }
            };
        };
        return _this;
    }
    MultiSelect.ofType = function () {
        return MultiSelect;
    };
    MultiSelect.prototype.render = function () {
        // omit props specific to this component, spread the rest.
        var _a = this.props, openOnKeyDown = _a.openOnKeyDown, popoverProps = _a.popoverProps, tagInputProps = _a.tagInputProps, restProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */](_a, ["openOnKeyDown", "popoverProps", "tagInputProps"]);
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](this.TypedQueryList, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, restProps, { onItemSelect: this.handleItemSelect, onQueryChange: this.handleQueryChange, ref: this.refHandlers.queryList, renderer: this.renderQueryList })));
    };
    MultiSelect.displayName = __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["h" /* DISPLAYNAME_PREFIX */] + ".MultiSelect";
    MultiSelect.defaultProps = {
        placeholder: "Search...",
    };
    return MultiSelect;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]));

//# sourceMappingURL=multiSelect.js.map

/***/ }),

/***/ 1261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__query_list_queryList__ = __webpack_require__(1254);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */






var Select = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](Select, _super);
    function Select(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.TypedQueryList = __WEBPACK_IMPORTED_MODULE_5__query_list_queryList__["a" /* QueryList */].ofType();
        _this.refHandlers = {
            input: function (ref) {
                _this.input = ref;
                var _a = _this.props.inputProps, inputProps = _a === void 0 ? {} : _a;
                __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(inputProps.inputRef, ref);
            },
            queryList: function (ref) { return (_this.list = ref); },
        };
        _this.renderQueryList = function (listProps) {
            // not using defaultProps cuz they're hard to type with generics (can't use <T> on static members)
            var _a = _this.props, _b = _a.filterable, filterable = _b === void 0 ? true : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.inputProps, inputProps = _d === void 0 ? {} : _d, _e = _a.popoverProps, popoverProps = _e === void 0 ? {} : _e;
            var input = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["n" /* InputGroup */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ leftIcon: "search", placeholder: "Filter...", rightElement: _this.maybeRenderClearButton(listProps.query) }, inputProps, { inputRef: _this.refHandlers.input, onChange: listProps.handleQueryChange, value: listProps.query })));
            var handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
            return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["t" /* Popover */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ autoFocus: false, enforceFocus: false, isOpen: _this.state.isOpen, disabled: disabled, position: __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["u" /* Position */].BOTTOM_LEFT }, popoverProps, { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(listProps.className, popoverProps.className), onInteraction: _this.handlePopoverInteraction, popoverClassName: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].SELECT_POPOVER, popoverProps.popoverClassName), onOpening: _this.handlePopoverOpening, onOpened: _this.handlePopoverOpened, onClosing: _this.handlePopoverClosing }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { onKeyDown: _this.state.isOpen ? handleKeyDown : _this.handleTargetKeyDown, onKeyUp: _this.state.isOpen ? handleKeyUp : undefined }, _this.props.children),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { onKeyDown: handleKeyDown, onKeyUp: handleKeyUp },
                    filterable ? input : undefined,
                    listProps.itemList)));
        };
        _this.handleTargetKeyDown = function (event) {
            // open popover when arrow key pressed on target while closed
            if (event.which === __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["p" /* Keys */].ARROW_UP || event.which === __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["p" /* Keys */].ARROW_DOWN) {
                event.preventDefault();
                _this.setState({ isOpen: true });
            }
        };
        _this.handleItemSelect = function (item, event) {
            _this.setState({ isOpen: false });
            __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(_this.props.onItemSelect, item, event);
        };
        _this.handlePopoverInteraction = function (isOpen) {
            _this.setState({ isOpen: isOpen });
            var _a = _this.props.popoverProps, popoverProps = _a === void 0 ? {} : _a;
            __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(popoverProps.onInteraction, isOpen);
        };
        _this.handlePopoverOpening = function (node) {
            var _a = _this.props, _b = _a.popoverProps, popoverProps = _b === void 0 ? {} : _b, resetOnClose = _a.resetOnClose;
            // save currently focused element before popover steals focus, so we can restore it when closing.
            _this.previousFocusedElement = document.activeElement;
            if (resetOnClose) {
                _this.resetQuery();
            }
            __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(popoverProps.onOpening, node);
        };
        _this.handlePopoverOpened = function (node) {
            // scroll active item into view after popover transition completes and all dimensions are stable.
            if (_this.list != null) {
                _this.list.scrollActiveItemIntoView();
            }
            requestAnimationFrame(function () {
                var _a = _this.props.inputProps, inputProps = _a === void 0 ? {} : _a;
                // autofocus is enabled by default
                if (inputProps.autoFocus !== false && _this.input != null) {
                    _this.input.focus();
                }
            });
            var _a = _this.props.popoverProps, popoverProps = _a === void 0 ? {} : _a;
            __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(popoverProps.onOpened, node);
        };
        _this.handlePopoverClosing = function (node) {
            // restore focus to saved element.
            // timeout allows popover to begin closing and remove focus handlers beforehand.
            requestAnimationFrame(function () {
                if (_this.previousFocusedElement !== undefined) {
                    _this.previousFocusedElement.focus();
                    _this.previousFocusedElement = undefined;
                }
            });
            var _a = _this.props.popoverProps, popoverProps = _a === void 0 ? {} : _a;
            __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(popoverProps.onClosing, node);
        };
        _this.resetQuery = function () { return _this.list && _this.list.setQuery("", true); };
        _this.state = { isOpen: false };
        return _this;
    }
    Select.ofType = function () {
        return Select;
    };
    Select.prototype.render = function () {
        // omit props specific to this component, spread the rest.
        var _a = this.props, filterable = _a.filterable, inputProps = _a.inputProps, popoverProps = _a.popoverProps, restProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */](_a, ["filterable", "inputProps", "popoverProps"]);
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](this.TypedQueryList, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, restProps, { onItemSelect: this.handleItemSelect, ref: this.refHandlers.queryList, renderer: this.renderQueryList })));
    };
    Select.prototype.componentDidUpdate = function (_prevProps, prevState) {
        if (this.state.isOpen && !prevState.isOpen && this.list != null) {
            this.list.scrollActiveItemIntoView();
        }
    };
    Select.prototype.maybeRenderClearButton = function (query) {
        return query.length > 0 ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["c" /* Button */], { icon: "cross", minimal: true, onClick: this.resetQuery }) : undefined;
    };
    Select.displayName = __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["h" /* DISPLAYNAME_PREFIX */] + ".Select";
    return Select;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]));

//# sourceMappingURL=select.js.map

/***/ }),

/***/ 1262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Suggest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__query_list_queryList__ = __webpack_require__(1254);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */






var Suggest = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](Suggest, _super);
    function Suggest(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.TypedQueryList = __WEBPACK_IMPORTED_MODULE_5__query_list_queryList__["a" /* QueryList */].ofType();
        _this.refHandlers = {
            input: function (ref) {
                _this.input = ref;
                var _a = _this.props.inputProps, inputProps = _a === void 0 ? {} : _a;
                __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(inputProps.inputRef, ref);
            },
            queryList: function (ref) { return (_this.queryList = ref); },
        };
        _this.renderQueryList = function (listProps) {
            var _a = _this.props, _b = _a.inputProps, inputProps = _b === void 0 ? {} : _b, _c = _a.popoverProps, popoverProps = _c === void 0 ? {} : _c;
            var _d = _this.state, isOpen = _d.isOpen, selectedItem = _d.selectedItem;
            var handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
            var _e = inputProps.placeholder, placeholder = _e === void 0 ? "Search..." : _e;
            var selectedItemText = selectedItem ? _this.props.inputValueRenderer(selectedItem) : "";
            return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["t" /* Popover */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ autoFocus: false, enforceFocus: false, isOpen: isOpen, position: __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["u" /* Position */].BOTTOM_LEFT }, popoverProps, { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(listProps.className, popoverProps.className), onInteraction: _this.handlePopoverInteraction, popoverClassName: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* Classes */].SELECT_POPOVER, popoverProps.popoverClassName), onOpened: _this.handlePopoverOpened }),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["n" /* InputGroup */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, inputProps, { placeholder: isOpen && selectedItemText ? selectedItemText : placeholder, inputRef: _this.refHandlers.input, onChange: listProps.handleQueryChange, onFocus: _this.handleInputFocus, onKeyDown: _this.getTargetKeyDownHandler(handleKeyDown), onKeyUp: _this.getTargetKeyUpHandler(handleKeyUp), value: isOpen ? listProps.query : selectedItemText })),
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { onKeyDown: handleKeyDown, onKeyUp: handleKeyUp }, listProps.itemList)));
        };
        _this.selectText = function () {
            // wait until the input is properly focused to select the text inside of it
            requestAnimationFrame(function () {
                if (_this.input != null) {
                    _this.input.setSelectionRange(0, _this.input.value.length);
                }
            });
        };
        _this.handleInputFocus = function (event) {
            var _a = _this.props, openOnKeyDown = _a.openOnKeyDown, _b = _a.inputProps, inputProps = _b === void 0 ? {} : _b;
            _this.selectText();
            // TODO can we leverage Popover.openOnTargetFocus for this?
            if (!openOnKeyDown) {
                _this.setState({ isOpen: true });
            }
            __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(inputProps.onFocus, event);
        };
        _this.handleItemSelect = function (item, event) {
            var nextOpenState;
            if (!_this.props.closeOnSelect) {
                if (_this.input != null) {
                    _this.input.focus();
                }
                _this.selectText();
                nextOpenState = true;
            }
            else {
                if (_this.input != null) {
                    _this.input.blur();
                }
                nextOpenState = false;
            }
            // the internal state should only change when uncontrolled.
            if (_this.props.selectedItem === undefined) {
                _this.setState({
                    isOpen: nextOpenState,
                    selectedItem: item,
                });
            }
            else {
                // otherwise just set the next open state.
                _this.setState({ isOpen: nextOpenState });
            }
            __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(_this.props.onItemSelect, item, event);
        };
        _this.handlePopoverInteraction = function (nextOpenState) {
            return requestAnimationFrame(function () {
                var _a = _this.props.popoverProps, popoverProps = _a === void 0 ? {} : _a;
                if (_this.input != null && _this.input !== document.activeElement) {
                    // the input is no longer focused so we can close the popover
                    _this.setState({ isOpen: false });
                }
                __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(popoverProps.onInteraction, nextOpenState);
            });
        };
        _this.handlePopoverOpened = function (node) {
            var _a = _this.props.popoverProps, popoverProps = _a === void 0 ? {} : _a;
            // scroll active item into view after popover transition completes and all dimensions are stable.
            if (_this.queryList != null) {
                _this.queryList.scrollActiveItemIntoView();
            }
            __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(popoverProps.onOpened, node);
        };
        _this.getTargetKeyDownHandler = function (handleQueryListKeyDown) {
            return function (evt) {
                var which = evt.which;
                var _a = _this.props, _b = _a.inputProps, inputProps = _b === void 0 ? {} : _b, openOnKeyDown = _a.openOnKeyDown;
                if (which === __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["p" /* Keys */].ESCAPE || which === __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["p" /* Keys */].TAB) {
                    if (_this.input != null) {
                        _this.input.blur();
                    }
                    _this.setState({
                        isOpen: false,
                    });
                }
                else if (openOnKeyDown &&
                    which !== __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["p" /* Keys */].BACKSPACE &&
                    which !== __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["p" /* Keys */].ARROW_LEFT &&
                    which !== __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["p" /* Keys */].ARROW_RIGHT) {
                    _this.setState({ isOpen: true });
                }
                if (_this.state.isOpen) {
                    __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(handleQueryListKeyDown, evt);
                }
                __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(inputProps.onKeyDown, evt);
            };
        };
        _this.getTargetKeyUpHandler = function (handleQueryListKeyUp) {
            return function (evt) {
                var _a = _this.props.inputProps, inputProps = _a === void 0 ? {} : _a;
                if (_this.state.isOpen) {
                    __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(handleQueryListKeyUp, evt);
                }
                __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["A" /* Utils */].safeInvoke(inputProps.onKeyUp, evt);
            };
        };
        _this.state = {
            isOpen: (props.popoverProps && props.popoverProps.isOpen) || false,
            selectedItem: _this.getInitialSelectedItem(),
        };
        return _this;
    }
    Suggest.ofType = function () {
        return Suggest;
    };
    Suggest.prototype.render = function () {
        // omit props specific to this component, spread the rest.
        var _a = this.props, inputProps = _a.inputProps, popoverProps = _a.popoverProps, restProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */](_a, ["inputProps", "popoverProps"]);
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](this.TypedQueryList, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, restProps, { onItemSelect: this.handleItemSelect, ref: this.refHandlers.queryList, renderer: this.renderQueryList })));
    };
    Suggest.prototype.componentWillReceiveProps = function (nextProps) {
        // If the selected item prop changes, update the underlying state.
        if (nextProps.selectedItem !== undefined && nextProps.selectedItem !== this.state.selectedItem) {
            this.setState({ selectedItem: nextProps.selectedItem });
        }
    };
    Suggest.prototype.componentDidUpdate = function (_prevProps, prevState) {
        if (this.state.isOpen && !prevState.isOpen && this.queryList != null) {
            this.queryList.scrollActiveItemIntoView();
        }
    };
    Suggest.prototype.getInitialSelectedItem = function () {
        // controlled > uncontrolled > default
        if (this.props.selectedItem !== undefined) {
            return this.props.selectedItem;
        }
        else if (this.props.defaultSelectedItem !== undefined) {
            return this.props.defaultSelectedItem;
        }
        else {
            return null;
        }
    };
    Suggest.displayName = __WEBPACK_IMPORTED_MODULE_3__blueprintjs_core__["h" /* DISPLAYNAME_PREFIX */] + ".Suggest";
    // Note: can't use <T> in static members, so this remains dynamically typed.
    Suggest.defaultProps = {
        closeOnSelect: true,
        openOnKeyDown: false,
    };
    return Suggest;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]));

//# sourceMappingURL=suggest.js.map

/***/ })

});


// WEBPACK FOOTER //
// static/js/homepage.489b66b4.chunk.js